export const state = () => ({
  showFirstContactModal: true
})
export const mutations = {
  setFirstContactModal(state, payload) {
    state.showFirstContactModal = payload
  }
}
